module.exports = __webpack_public_path__ + "img/03.bc46d607.jpg";